import { adminRouterMap, asyncRouterMap, constantRouterMap } from '@/router/index'

/**
 * Check if the user has permission to access a route
 */
function hasPermission(menus, route) {
  if (!route || !route.name) return false
  if (!Array.isArray(menus) || menus.length === 0) return false
  return menus.includes(route.name)
}

/**
 * Recursively filter routes — keeps parents if any child is permitted
 */
function filterAsyncRoutes(routes, menus) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }

    if (tmp.children && tmp.children.length > 0) {
      // recursively filter children
      tmp.children = filterAsyncRoutes(tmp.children, menus)

      // if any child remains, or parent route itself is permitted → keep it
      if (tmp.children.length > 0 || hasPermission(menus, tmp)) {
        res.push(tmp)
      }
    } else {
      // no children — check parent itself
      if (hasPermission(menus, tmp)) {
        res.push(tmp)
      }
    }
  })

  return res
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      const { menus, roleId } = data
      if(roleId == 1){
        const adminRouters = filterAsyncRoutes(adminRouterMap, menus)
        commit('SET_ROUTERS', adminRouters)  
        return adminRouters
      }
      const accessedRouters = filterAsyncRoutes(asyncRouterMap, menus)
      commit('SET_ROUTERS', accessedRouters)  
      return accessedRouters
    }
  }
}

// store/modules/permission.js (only relevant parts shown)


export default permission
